import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

export default () => (
  <SectionContainer
    id='physician-disability-insurance-faq' // '-section-container' will be appended dynamically
    className='nmx-no-print'
    backgroundVariant='lightA'
    themeType='lightTheme'
    moduleName='faq-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        small={10}
        medium={8}
        large={6}>
        <Typography
          component='h2'
          nextElement='typography'>
          Questions about physician disability insurance&#63; <WidowBlock>We&#39;ve got answers.</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id='faq-physician-disability-insurance'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          items={[
            {
              id: 'physician-disability-insurance-which-is-right-faq',
              title: <>Which type of physician disability insurance is right <WidowBlock>for me&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    The best option for you will depend on your specific needs. Keep in mind, it&#39;s important to work with a company that has a strong track record of financial strength and paying claims. Talk with an advisor about{' '}
                    <Link
                      linkUrl='/find-a-financial-advisor/'
                      id='physician-disability-insurance-faq-talk-to-advisor-about-type-of-coverage-link'
                      variant='primaryDeemphasize'>
                      which type of coverage is right for you
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'physician-disability-insurance-substantial-material-duties-faq',
              title: <>What are substantial and <WidowBlock>material duties&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Substantial and material duties are the acts required to perform your job and cannot be reasonably left out or modified. It&#39;s a key consideration when a claim is submitted, along with your earnings at the time of disability. Not sure which type of coverage is right for your occupation&#63;{' '}
                    <Link
                      linkUrl='/find-a-financial-advisor/'
                      id='physician-disability-insurance-faq-talk-to-advisor-for-type-of-coverage-link'
                      ariaLabel='Learn more about finding the right type of coverage for you with a financial advisor'
                      variant='primaryDeemphasize'>
                      Talk to an advisor
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'physician-disability-insurance-how-much-for-doctors-faq',
              title: <>How much disability insurance do doctors and <WidowBlock>dentists need&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    In general, you&#39;ll want to make sure you can replace around 60 percent of your income. If you have group disability coverage, you might be able to replace a bit more.{' '}
                    <Link
                      linkUrl='/find-a-financial-advisor/'
                      id='physician-disability-insurance-faq-talk-to-advisor-about-coverage-link'
                      variant='primaryDeemphasize'>
                      Talk to an advisor about how much coverage is right for you
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'physician-disability-insurance-how-much-do-you-get-faq',
              title: <>How much physician disability insurance can I get and when can I <WidowBlock>get it&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Many doctors first buy disability insurance when they are in residency (or when starting out for dentists), which would typically replace a little more than what you&#39;re making at the time. That&#39;s because your salary is likely to increase substantially down the road. As you make more, you&#39;ll likely want to increase your disability insurance benefit too. With that in mind, it could be a good idea to get a policy that offers an additional purchase benefit, which will allow you to buy more disability insurance<sup>2</sup> without having to take another health exam.{' '}
                    <Link
                      linkUrl='/find-a-financial-advisor/'
                      id='physician-disability-insurance-faq-talk-to-advisor-about-getting-right-coverage-link'
                      variant='primaryDeemphasize'>
                      Talk to an advisor about getting the right coverage at the right time
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'physician-disability-insurance-made-claim-on-policy-faq',
              title: <>What happens if I make a claim on my physician disability  <WidowBlock>insurance policy&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Policy details will vary by company, so make sure your policy defines disability based on your regular medical profession. Believe it or not, some policies will only pay you if you can&#39;t work in any profession. Then, ask how many ways there are to qualify for total disability. Many policies define total disability only one way. Our Medical True Own Occupation option offers multiple paths, which can give you more flexibility, particularly in a situation where a disability prevents you from doing a portion of your duties, but not all of them.{' '}
                    <Link
                      linkUrl='/find-a-financial-advisor/'
                      id='physician-disability-insurance-faq-questions-for-advisor-link'
                      variant='primaryDeemphasize'>
                      Talk with an advisor about what other questions you should ask
                    </Link>.
                  </Typography>
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
